<template>
  <el-container class="home-container">

<!--    <el-header>-->
<!--      <div>-->
<!--        <span>组态云平台</span>-->
<!--      </div>-->
      <!-- <el-button type="info" @click="logout">退出登录 </el-button> -->
<!--      <div>-->
<!--        <el-dropdown @command="handleCommand">-->
<!--					<span class="el-dropdown-link">-->
<!--						您好，用户<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--					</span>-->
<!--          <el-dropdown-menu slot="dropdown">-->
<!--            <el-dropdown-item command="userGroup">个人中心</el-dropdown-item>-->
<!--            <el-dropdown-item command="userGroup1">退出登录</el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
<!--      </div>-->
<!--    </el-header>-->
    <el-container>
      <!-- 侧边栏 -->
      <!-- 宽度是动态的 -->
      <el-aside :width="isCollapse? '14px':'300px'">
        <!-- 点击折叠菜单栏 -->
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <div class="toggle-button" style="font-size: 18px" @click="companyChange">{{this.companyName}}</div>
        <el-tree :props="defaultProps" :data="data" :highlight-current="true" @node-click="handleNodeClick"
                 node-key="uniqueId" ref="tree" :style="isCollapse? 'margin-left: 14px':''">
        </el-tree>
      </el-aside>
      <!-- <el-main style="z-index: -1 !important;pointer-events: auto;"> -->
      <el-main>
        <device-list v-if="stageType == 12" :companyId="companyId" @add="appendDevice" @delete="remove" @changeName="changeDeviceName"></device-list>
        <system-variable v-if="stageType ==8" :companyId="companyId"></system-variable>
        <device-total-variable v-if="stageType == 9" :companyId="companyId" @autopick="autopick"></device-total-variable>
        <device-detailed-variable v-if="stageType == 13" :companyId="companyId" :deviceId="node.id"></device-detailed-variable>
        <custom-variable v-if="stageType == 11" :companyId="companyId" ></custom-variable>
        <projectList v-if="stageType == 1" :companyId="companyId" @add="append" @delete="remove" @changeName="changeName" @autoPick="autopick"/>
        <productList v-if="stageType == 2" :companyId="companyId" :projectId="node.id" @delete="remove" @add="appendpage" @changeName="changeName"  @autoPick="autopick" @autoPickOther="autopick"></productList>
        <the-create v-if="stageType === 3" :companyId="companyId" :productId="node.id" :projectId="parseInt(projectId)"
                :editType="1" @toNewPage="toNewPage" @saveAs="saveAs" ref="create" @testback="testback" @switchPage="switchPage">
        </the-create>
        <map-product v-if="stageType == 20" ref="map" :data="node" :companyId="companyId" :productId="node.id" :projectId="projectId" @testback="testback"></map-product>
        <alert-product v-if="stageType == 21" :data="node" :companyId="companyId" :productId="node.id" :projectId="projectId"></alert-product>
        <history-product v-if="stageType == 22" :data="node" :companyId="companyId" :productId="node.id" :projectId="projectId"></history-product>
        <script-list v-if="stageType==4" :companyId="companyId"  @delete="remove" @add="append" @changeName="changeName" @autoPick="autopick" @autoPickOther="autopick"></script-list>

        <create-script v-if="stageType==5" :companyId="companyId" :scriptId="node.id" :updateVariableId="updateVariableId" ref="script" @testback="testback"></create-script>

        <program-list v-if="stageType==6" :companyId="companyId"  @delete="remove" @add="append" @changeName="changeName" @autoPick="autopick" @autoPickOther="autopick"></program-list>

        <edit-program v-if="stageType==7" :companyId="companyId"  :programId="node.id" ref="program" @testback="testback"></edit-program>


        <user-permission v-if="stageType==10" :companyId="companyId"> </user-permission>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import API from "@/../config/api.js";
import ProjectList from "@/components/ProductComponents/ProjectList";
import ProductList from "@/components/ProductComponents/ProductList";
import TheCreate from "../../components/ProductComponents/TheCreate";
import DeviceList from "@/components/DeviceComponents/DeviceList";
import CustomVariable from "@/components/VariableComponents/CustomVariable";
import SystemVariable from "@/components/VariableComponents/SystemVariable";
import DeviceTotalVariable from "@/components/VariableComponents/DeviceTotalVariable";
import DeviceDetailedVariable from "@/components/VariableComponents/DeviceDetailedVariable";
import CreateScript from "@/components/ScriptComponents/CreateScript";
import HistoryProduct from "@/components/ProductComponents/HistoryProduct";
import AlertProduct from "@/components/ProductComponents/AlertProduct";
import MapProduct from "@/components/ProductComponents/MapProduct";
import UserPermission from "@/components/UserComponents/UserPermission";
import ScriptList from "@/components/ScriptComponents/ScriptList";
import ProgramList from "@/components/ProgramComponents/ProgramList";
import EditProgram from "@/components/ProgramComponents/EditProgram";

export default {
  components: {
    ScriptList,
    ProgramList,
    EditProgram,
    UserPermission,
    DeviceDetailedVariable,
    DeviceTotalVariable,
    ProjectList,
    ProductList,
    CreateScript,
    TheCreate,
    DeviceList,
    SystemVariable,
    CustomVariable,
    HistoryProduct,
    AlertProduct,
    MapProduct
  },
  data() {
    return {
      companyId: '',
      companyName:'',
      projectId: '', //为了传入创作页面另存操作
      // productId:'',
      //控制是否折叠
      isCollapse: false,
      data: [
        {
          label: '变量',
          id: 1,
          stageType: 11, //此页没有页面
          uniqueId: 'fixed_1',
          children: [{
            label: '用户变量',
            id: 4,
            stageType: 11,
            uniqueId: 'fixed_4',
          },{
            label: '设备变量',
            id: 3,
            stageType: 9,
            uniqueId: 'fixed_3',
            children: []
          },{
            label: '系统变量',
            id: 2,
            stageType: 8,
            uniqueId: 'fixed_2',
          }, ]
        },
        {
          label: '设备',
          id: 5,
          stageType: 12,
          uniqueId: 'fixed_5',
        },
        {
          label: '项目',
          id: 6,
          stageType: 1,
          uniqueId: 'fixed_6',
          children: []
        },
        {
          label: '脚本',
          id: 7,
          stageType: 4,
          uniqueId: 'fixed_7',
          children: []
        },
        {
          label: '程序',
          id: 8,
          stageType: 6,
          uniqueId: 'fixed_8',
          children: [],
        },
        {
          label: '用户',
          id: 9,
          stageType: 10,
          uniqueId: 'fixed_9',
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      stageType: "", //控制组件显示
      node: {}, //记录当前节点,里面就有id
      tmpNode: {},   // 记录点击项目的节点,每次新建页面时node回来
      //记录是第几次展开节点
      expand1: 0,
      expand2: 0,
      expand3: 0,
      expand4: 0,
      updateVariableId: 0, //记录新增脚本的主变量
    }
  },
  mounted: function () {
    this.userId = window.localStorage.getItem("userid")
    this.companyId = parseInt(this.$route.query.companyId);
    this.companyName = window.localStorage.getItem("companyName");
    //开始时默认选中用户变量
    this.autopick({
      label: '用户变量',
      id: 4,
      stageType: 11,
      uniqueId: 'fixed_4',
    })
    // this.getData(); //起初获取菜单第一级的选项
  },
  methods: {
    //下拉菜单的点击跳转
    handleCommand(cmditem) {
      switch (cmditem) {
        case "userGroup":
          this.userGroup();
          break;
        case "userGroup1":
          this.userGroup1();
          break;
      }
    },
    userGroup() {
      this.$router.push({path: '/pages/userCenter/UserCenter'})
    },
    userGroup1() {
      this.$router.push({path: '/pages/login/PcLogin'})
    },
    //点击菜单不同的按键触发的
    handleNodeClick(node) { //此处的node其实是文档中的data
      //用于组态页面切换的时候提醒保存
      console.log("node", node, this.stageType)
      if ((this.node.stageType == 3) &&(this.node.uniqueId != node.uniqueId)) { //当原本是创作页面的时候，切换其他任何页面作保存提示
          this.$refs.create.change(this.test.bind(this), node);
      } else if ((this.node.stageType == 5) &&(this.node.uniqueId != node.uniqueId)) {
          this.$refs.script.change(this.test.bind(this), node);
      } else if ((this.node.stageType === 7)&&(this.node.uniqueId !== node.uniqueId)) {
          this.$refs.program.change(this.test.bind(this), node);
      }
      else if ((this.node.stageType == 20)&&(this.node.uniqueId != node.uniqueId)) {
          this.$refs.map.change(this.test.bind(this), node);
      } else {
        //记录页面对应的项目id，用于另存为
        //console.log("当前节点的类型为",node.stageType, typeof node.stageType)
        if (node.stageType === 2) {
          this.tmpNode = node;
        }
        if (node.stageType === 3) {
          this.projectId = node.projectId;
        }
        if (node.stageType == this.stageType) { //解决同级组件切换页面不刷新的问题
          // if (node.stageType == 3) { //创作页面单独处理
          // 	if (this.node.id != node.id) {            //如果是页面点击本身就不用刷新了
          // 		this.stageType = 0;
          // 		setTimeout(() => {                    //时间延迟达到刷新效果
          // 			this.stageType = node.stageType  //控制右边的组件的展示
          // 		});
          // 	}
          // } else { //其余全部刷新
          this.stageType = 0;
          setTimeout(() => {
            this.stageType = node.stageType
          });
          // }
        } else {
          this.stageType = node.stageType; //控制右边的组件的展示
          if (this.stageType === undefined) this.stageType = 7
        }
        this.node = node; //全局记录选中节点,用于新建和删除后重新加载子节点
        //下方是获取子节点代码
        if (node.stageType == 1 || node.stageType == 2 || node.stageType == 4 || node.stageType === 6) { //判断是否是第一次展开节点
          if (node.stageType == 1 && this.expand1 == 0) {
            this.getAllProjectOfCompany(node); //展开父节点获得子节点公司每个项目
          }
          if (node.stageType == 4 && this.expand3 == 0) {
            this.getScriptList(node); //展开父节点获得子节点脚本页面
          }
          if (node.stageType == 2 ) {
            this.getProductList(node);//展开父节点获得子节点项目页面
          }else if (node.stageType === 6 ) {
            this.getProgramList(node);

          }
        }  else if (node.stageType == 9 ) {
          this.getDeviceList(node); //展开父节点获得子节点设备变量
        }
        switch (node.stageType) {
          case 1:
            this.expand1 = 1;
            break;
          case 4:
            this.expand3 = 1;
            break;
        }
      }
    },
    // 切换的当前项目的新建页面
    toNewPage() {
      this.handleNodeClick(this.tmpNode)
    },
    //切换页面的保存
    test(node) {
      //记录页面对应的项目id，用于另存为
      if (node.stageType == 3) {
        this.projectId = node.projectId;
      }

      if (node.stageType == this.stageType) { //解决同级组件切换页面不刷新的问题
        this.stageType = 0;
        setTimeout(() => {
          this.stageType = node.stageType
        });
      } else {
        this.stageType = node.stageType; //控制右边的组件的展示
      }
      this.node = node; //全局记录选中节点,用于新建和删除后重新加载子节点
      //下方是获取子节点代码
      if (node.stageType == 1 || node.stageType == 2 || node.stageType == 4 || node.stageType == 6) { //判断是否是第一次展开节点
        if (node.stageType == 1 && this.expand1 == 0) {
          this.getAllProjectOfCompany(node); //展开父节点获得子节点公司每个项目
        }
        if (node.stageType == 4 && this.expand3 == 0) {
          this.getScriptList(node); //展开父节点获得子节点脚本页面
        }
        if (node.stageType == 2 ) {
          this.getProductList(node);//展开父节点获得子节点项目页面
        }else if (node.stageType == 6 && this.expand4 == 0) {
          this.getProgramList(node);
          this.expand4 = 1
        }

      }  else if (node.stageType == 9 ) {
        this.getDeviceList(node); //展开父节点获得子节点设备变量
      }
      switch (node.stageType) {
        case 1:
          this.expand1 = 1;
          break;
        case 4:
          this.expand3 = 1;
          break;
      }
    },
    //从创作页面取消跳转之后的默认选中
    testback() {
      this.$refs.tree.setCurrentKey(this.node.uniqueId); //实现默认选中原本页面状态
    },
    //从创作页面的页面跳转触发的事件，任何项目都可以
    switchPage(switchItem) {
      this.$refs.tree.setCurrentKey(switchItem.id); //实现默认选中原本页面状态
      this.projectId = switchItem.projectId;
      for (let i = 0; i < this.data[2].children.length; i++) {
        if (this.data[2].children[i].id == switchItem.projectId) {
          for (let j = 0; j < this.data[2].children[i].children.length; j++) {
            if (this.data[2].children[i].children[j].id == switchItem.id) {
              this.node = this.data[2].children[i].children[j];
              this.stageType = 0;
              setTimeout(() => {
                this.stageType = this.node.stageType
              });
              return;
            }

          }
        }
      }
    },
    //从设备变量自动选中子树中的设备展示设备页面
    autopick(item) {
      this.$refs.tree.setCurrentKey(item.uniqueId); //实现默认选中状态
      this.stageType = item.stageType; //控制右边的组件的展示
      this.node = item; //全局记录选中节点,用于新建和删除后重新加载子节点
    },
    //点击按钮，切换菜单的折叠与展开
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    //获取项目下方的各个项目子树,已经调通
    getAllProjectOfCompany(node) {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
      }
      this.$axiosRequest({
        url: API.getAllProjectOfCompany,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          //console.log(res)
          let project = res.data["projectList"]
          for (let i = 0; i < project.length; i++) {
            project[i].children = [];     //先给每个项目增加children属性
          }
          node.children = project;//根据后端返回的形式
          //console.log(this.data)
        }
      });
    },
    //获取项目下的页面列表
    getProductList(node) {
      let data = {
        projectId: node.id,
        companyId: this.companyId,   // 传入项目id和公司id即可
      }
      this.$axiosRequest({
        url: API.getProductList,
        method: 'POST',
        data: data,
        success: res => {
          let productList = res.data["productList"];
          node.children = productList;      //更新当前节点的儿子节点
        }
      });

    },
    // 获取程序下面各个程序的子树
    getProgramList(node) {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded",
      }

      let data = {
        companyId: this.companyId

      }
      this.$axiosRequest({
        url: API.getPLCList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          node.children = res.data["plcList"];
        }
      });
    },
    //获取脚本下面的各个脚本的子树
    getScriptList(node) {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded",
      }

      let data = {
        companyId: this.companyId

      }
      this.$axiosRequest({
        url: API.getScriptList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          let scriptList = res.data["scriptList"];
          node.children = scriptList;
        }
      });

    },
    //获取设备变量子树
    getDeviceList(node) {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        device_type: 1,
      }
      console.log(data)
      this.$axiosRequest({
        url: API.getDeviceList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res.data)
          let deviceList = res.data["deviceList"]
          node.children = deviceList;
        }
      });
    },
    //为项目和脚本这种新建子节点时，同级子节点需要保持原有展开状态，设计的回调函数
    append(newChild) {
      this.$refs.tree.append(newChild, this.node); //实现增加节点
      //下面是自己实现
      // if (!this.node.children) {
      // 	this.$set(this.node, 'children', []);
      // }
      // this.node.children.push(newChild);
      this.$refs.tree.setCurrentKey(newChild.uniqueId); //实现默认选中状态
      this.stageType = newChild.stageType; //控制右边的组件的展示
      this.node = newChild; //全局记录选中节点,用于新建和删除后重新加载子节点
      if (newChild.stageType == 5)
        this.updateVariableId = newChild.updateVariableId
    },
    //为项目和脚本这种删除子节点时，同级子节点需要保持原有展开状态，设计的回调函数，页面也用了
    remove(delChild) {
      this.$refs.tree.remove(delChild);
    },
    //为项目2-1新增创作页面
    appendpage(startParam) {
      let newChild = {
        label: startParam.title,
        id: startParam.productId,
        stageType: startParam.stageType,
        uniqueId: startParam.uniqueId
      }
      this.$refs.tree.append(newChild, this.node); //实现增加节点
      console.log('uuuuuuuuuu', this.node)
      this.$refs.tree.setCurrentKey(newChild.uniqueId); //实现默认选中状态
      this.projectId = startParam.projectId; //传入创作页面,另存为操作
      this.stageType = newChild.stageType; //控制右边的组件的展示
      this.node = newChild; //全局记录选中节点,用于新建和删除后重新加载子节点
      // this.productId=newChild.id;
    },
    //设备新增之后
    appendDevice(newChild) {
      let aimNode = this.data[0].children[1];
      this.$refs.tree.append(newChild, aimNode); //实现增加节点
    },
    //另存为新增节点
    saveAs(saveAsChild) {
      console.log("eeeeeee", saveAsChild)
      let newChild = {
        label: saveAsChild.title,
        id: saveAsChild.productId,
        stageType: saveAsChild.stageType
      }
      for (let i = 0; i < this.data[2].children.length; i++) {
        if (this.data[2].children[i].id == saveAsChild.projectId) {
          //this.$refs.tree.append(newChild, this.data[1].children[i]);    //实现增加节点
          this.data[2].children[i].children.push(newChild);
          console.log("aaaaaaaaaaaa", this.data[2].children[i])
          break;
        }
      }
    },

    //项目或者页面改名
    changeName(tempTitle, tempId) {
      console.log('ttttttt', tempTitle, tempId)
      for (let i = 0; i < this.node.children.length; i++) {
        if (this.node.children[i].id == tempId) {
          this.node.children[i].label = tempTitle;
          break;
        }
      }
    },
    //设备改名字的时候设备变量下方的内容
    changeDeviceName(tempTitle, tempId) {
      console.log('eeeeeeeeeeee')
      for (let i = 0; i < this.data[0].children[1].children.length; i++) {
        if (this.data[0].children[1].children[i].id == tempId) {
          this.data[0].children[1].children[i].label = tempTitle;
          break;
        }
      }
    },
    //切换公司
    companyChange(){
        this.$axiosRequest({
          url: API.getUserCompanyList,
          method: 'POST',
          data: {},
          success: res1 => {
            if (res1.data["companyList"].length == 0) {
              this.$router.push({path: '/pages/userCenter/UserCenter'})
            } else if (res1.data["companyList"].length == 1) {
              return
            } else {
              window.localStorage.removeItem("companyId")
              window.localStorage.removeItem("companyRoleType")
              window.localStorage.removeItem("companyName")
              this.$router.push({path: '/pages/login/LoginCompanySelect'})
            }
          }
        });
    },
    //除了项目脚本这种需要保持展开形式的，其余比如项目2-1这种下方子节点页面直接每次都从后端获取即可
    renewProject() {
      //刷新子节点
      /*之后打开
      let params = {
        pid:  this.node.id, //父节点id
        stageType:this.node.stageType
      }
      this.$axiosRequest({
         url: API.getDataUrl,
         method:'POST',
         data: params,
         header: header,
         success: res => {
           console.log(res.data)
           if (list.length > 0) {
             this.node.children = res.data.list.children  //根据后端返回的形式
           }
         }
      });*/
      // this.node.children = [{
      //   label: '项目 2-1',
      //   stageType: 2,
      //   id: 51,
      //   children: [{
      //     label: '页面 2-1-1',
      //     stageType: 3
      //   }]
      // }, {
      //   label: '项目 2-2',
      //   stageType: 2,
      //   id: 52,
      //   children: [{
      //     label: '页面 2-2-1',
      //     stageType: 3
      //   }]
      // }, {
      //   label: ' 脚本',
      //   children: [{
      //     label: '二级 3-1',
      //     children: [{
      //       label: '三级 3-1-1'
      //     }]
      //   }, {
      //     label: '二级 3-2',
      //     children: [{
      //       label: '三级 3-2-1'
      //     }]
      //   }]
      //
      // }];


    },

  }
}
</script>

<style lang="less" scoped>
//lang=“less” 可以敲层级关系的样式
//scoped 使style内的样式只作用于当前的界面
.home-container {
  height: 89vh;
  width: 100%;
}


/*element-ui中每一个组件的标签可以作为类名 */
.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  /* 按钮居中 */
  align-items: center;
  color: #ffffff;
  font-size: 20px;

}

.el-aside {
  background-color: #333744;
  border-right: none;
}

.el-main {
  background-color: #EAEDF1;

}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-tree {
  background-color: rgba(135, 206, 235, 0.2);
  color: #ffffff;
}

/deep/ .el-tree-node__label {
  width: auto;
  float: right;
  font-size: 18px;
  letter-spacing: 1px; //字间距
}

//高亮背景色设置
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #ffffff;
  font-weight: bold;
  background-color: rgba(135, 206, 235, 0.2);
}

//悬浮颜色设置
/deep/ .el-tree-node__content {
  &:hover {
    background: #89c2f7;
  }
}

/* 侧边栏的展开的收缩 */
.toggle-button {
  background-color: #4C5064;
  font-size: 10px;
  line-height: 24px;
  color: #FFFFFF;
  text-align: center;
  /* 让三条线之间有距离 */
  letter-spacing: 0.2em;
  /* 手表放上去会出现小手 */
  cursor: pointer;
}
</style>


<!--  updateTableStructure(tableProps) {  //修改表头结构
            let leaves = []
            for (let i = 0; i < this.detailedConditions.indicatorIds.length; i++) { 
                leaves.push({
                    prop: this.detailedConditions.indicatorIds[i].value.toString(),  
                    label: this.detailedConditions.indicatorIds[i].label
                })
            }
            tableProps.tableColumn[1].children = leaves  //给第一行表头的指标名那一列的children添加prop和label子列
        }, -->

<!-- handleNodeClick(node) {
    let children = getChildren(node.id)

    node.children = children
} -->
